import { PressableScale } from "pressto";
import { View, Text } from "@src/components";
import { Icon } from "@src/components/Icon";
import { useUnistyles } from "react-native-unistyles";
import { EmbeddedAgentScreen } from "@src/features/agent/components/AgentScreenContent";

interface AgentSidePanelProps {
  onClose: () => void;
}

export function AgentSidePanel({ onClose }: AgentSidePanelProps) {
  const { theme } = useUnistyles();

  return (
    <View flex={1} height="100%">
      <View flexDirection="row" alignItems="flex-start" justifyContent="space-between" mb="6xl" gap="md">
        <View flex={1} gap="xs">
          <Text textStyle="sm/regular" color="text">
            AI Schedule Assistant
          </Text>
          <Text textStyle="xs/regular" color="textMuted">
            Configure schedules with natural language.
          </Text>
        </View>
        <PressableScale onPress={onClose}>
          <View
            width={32}
            height={32}
            borderRadius={16}
            alignItems="center"
            justifyContent="center"
            bg="surface"
            borderWidth={1}
            borderColor="borderCard"
          >
            <Icon name="close" size={16} />
          </View>
        </PressableScale>
      </View>

      <View height={1} bg="borderCard" mb="3xl" />

      <View
        flex={1}
        style={{ borderRadius: 12, overflow: "hidden", borderWidth: 1, borderColor: theme.colors.borderCard }}
      >
        <EmbeddedAgentScreen />
      </View>
    </View>
  );
}
